import { useMutation, useQueryClient } from '@tanstack/react-query';
import { closeProjet } from '../../api/PROJETS/projets';


export const useCloseProjet = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: closeProjet,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projets'] });
    },
  });
};
